import { useState, useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import Loading from 'app/common/components/Loader'
import Modal from 'app/common/components/Modal' // TODO заменить на PlainModal
import { BannerContent } from 'app/common/components-next/banner'
import { PageTemplateContent } from 'app/common/templates-next/page-template'
import PlainButton from 'app/common/ui-next/plain-button'

import { useCustomerSettings, useCustomerPinGenerate } from '../dataProviders/customer/hooks'
import styles from './Pin.module.scss';


type Props = {
  customerID: string
}

export const Pin = ({ customerID }: Props) => {
  const { t } = useTranslation('cafeteria')

  const [currentlyPinActivated, setCurrentlyPinActivated] = useState(false)
  const { settings: customerSettings, loading } = useCustomerSettings({ params: { customerID } })
  const { pinEnabled, pinActivated, pinReason } = customerSettings

  useEffect(() => {
    setCurrentlyPinActivated(pinActivated)
  }, [pinActivated])

  const [showPin, setShowPin] = useState(false)
  const { pin, generate } = useCustomerPinGenerate(customerID)
  const [generating, setGenerating] = useState(false)

  useEffect(() => {
    if (pin) setShowPin(true)
  }, [pin])

  const handleGeneratePin = useCallback(async () => {
    setGenerating(true)
    await generate()
    setGenerating(false)
  }, [generate])

  const handleAcceptPin = useCallback(() => {
    setShowPin(false)
    setCurrentlyPinActivated(true)
  }, [])

  return (
    <PageTemplateContent className={styles.root} skipPadding>
      <div className={styles.content}>

        {loading && <Loading />}

        {!loading && pinEnabled && currentlyPinActivated
          && <div>
            <div className={styles.text}>
              {t('settings_pin_exist_line1', 'Пин-код уже установлен.')}
              <br />
              {t('settings_pin_exist_line2', 'Если Вы его забыли, Вы можете сгенерировать новый.')}
            </div>
            <div className={styles.textComment}>
              {t('settings_pin_exist_line3', 'В этом случае старый пин-код перестанет быть действительным.')}
            </div>
            <PlainButton
              className={styles.button}
              onClick={handleGeneratePin}
              disabled={generating}
            >
              {generating
                ? t('settings_pin_generate_bt_process', 'Генерируется...')
                : t('settings_pin_generate_bt', 'Сгенерировать')}
            </PlainButton>
          </div>}

        {!loading && pinEnabled && !currentlyPinActivated
          && <div>
            <div className={styles.text}>
              {t('settings_pin_absent_line1', 'Для покупок в терминале с помощью карты')}
              <br />
              {t('settings_pin_absent_line2', 'Вам необходимо активировать пин-код.')}
            </div>
            <PlainButton
              className={styles.button}
              onClick={handleGeneratePin}
              disabled={generating}
            >
              {generating
                ? t('settings_pin_activate_bt_process', 'Активируется...')
                : t('settings_pin_activate_bt', 'Активировать')}
            </PlainButton>
          </div>}

        {!loading && !pinEnabled
          && <div>
            <div className={styles.text}>
              {t('settings_pin_denied', 'Невозможно сгенерировать пин-код.')}
            </div>
            <div className={styles.textComment}>
              {pinReason}
            </div>
          </div>}

        {showPin
          && <Modal>
            <div className={styles.modalContent}>
              <div className={styles.modalHeader}>
                {currentlyPinActivated
                  ? t('settings_pin_generate_modal_header_new', 'Новый пин-код')
                  : t('settings_pin_generate_modal_header', 'Ваш пин-код')}
              </div>
              <div className={styles.code}>
                {pin}
              </div>
              <div className={styles.modalComment}>
                {currentlyPinActivated
                  ? t('settings_pin_generate_modal_content_line1_new', 'Внимание! Запомните новый пин-код.')
                  : t('settings_pin_generate_modal_content_line1', 'Внимание! Запомните пин-код.')}
                <br />
                {t(
                  'settings_pin_generate_modal_content_line2',
                  'После закрытия окна, Вы не сможете его посмотреть снова.',
                )}
              </div>
              <PlainButton onClick={handleAcceptPin}>
                {t('settings_pin_generate_modal_ok_bt', 'OK')}
              </PlainButton>
            </div>
          </Modal>}

      </div>

      {/* TODO Вынести на локальный уровень */}
      <BannerContent
        // leaveContainerOnEmpty
        refreshOnMount
        className={styles.bannerContent}
        placeId="d099e4c6-f44b-42ef-b5f9-a1d52c27dee5"
      />

    </PageTemplateContent>
  )
}
